import { useState } from 'react';
import { Link } from 'react-router-dom';

import { type OperationDetail } from '@/shared/api/resources';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';
import { Select } from '@/shared/ui/Select';
import { Timeline } from '@/shared/ui/Timeline';

import { itemDaLinhaDoTempo, origensDoFollowUp } from './acompanhamento';
import { CommentsPanel, PendingsPanel } from './DemandPanels';

/**
 * Aba Follow up da cotacao (COT-033, COT-087, COT-088; P-COT-3).
 *
 * No OnPoint cada item do Follow up tem a situacao ("Analise de mesa de cadastro") e a
 * origem (Cadastro, Credito, PEP...). Aqui a aba junta, com o filtro de origem: as
 * pendencias das areas (com as origens Cadastro, PEP e Resseguro), a conversa com a
 * esteira de origem de cada mensagem (P-EST-1) e a linha do tempo classificada. A
 * conversa respeita o lado de quem le: a corretora so ve o que escreveu e o que foi
 * enviado a ela.
 */
export function FollowUpTab({ operacao }: { operacao: OperationDetail }) {
  const [origem, setOrigem] = useState('');

  const itens = operacao.timeline
    .filter((evento) => !origem || evento.situation_group === origem)
    .map(itemDaLinhaDoTempo);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="w-full sm:w-64">
          <Select
            label="Origem"
            options={origensDoFollowUp}
            value={origem}
            onChange={(event) => setOrigem(event.target.value)}
          />
        </div>
        <Link
          to={`/operacoes/${operacao.id}/linha-do-tempo`}
          className="inline-flex h-10 items-center rounded-md px-3 text-sm font-medium text-brand-700 transition-colors duration-(--duration-fast) hover:bg-brand-50"
        >
          Abrir a linha do tempo da cotacao
        </Link>
      </div>

      <div className="grid gap-5 lg:grid-cols-2">
        <div className="flex flex-col gap-5">
          <PendingsPanel operationId={operacao.id} origem={origem || undefined} />
          <CommentsPanel operationId={operacao.id} origem={origem || undefined} />
        </div>
        <Card>
          <CardHeader
            title="Linha do tempo"
            description="Historico completo, apenas leitura, com a situacao, o status e o lado de quem executou."
          />
          {itens.length === 0 && origem ? (
            <CardBody>
              <p className="text-sm text-ink-500">Nenhum registro desta origem.</p>
            </CardBody>
          ) : (
            <Timeline items={itens} />
          )}
        </Card>
      </div>
    </div>
  );
}
